import { EspaciosService, Horario, Imagen } from '../../../servicios/espacios.service';
import { ToastService } from '../../../servicios/toast.service';
import { ActivatedRoute } from '@angular/router';
import { LugaresService, Lugar } from '../../../servicios/lugares.service';
import { HeaderInfoService } from '../../../servicios/header-info.service';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { opciones } from './opciones';
import { listaDias, listaHoras } from './listas';

export interface InformacionBasicaEspacio {
  nombre: string;
  descripcion: string;
  estado: number;
}
@Component({
  selector: 'app-detalle-espacio',
  templateUrl: './detalle-espacio.component.html',
  styleUrls: ['./detalle-espacio.component.scss'],
})
export class DetalleEspacioComponent implements OnInit {
  constructor(
    private toastService: ToastService,
    private headerInfoService: HeaderInfoService,
    private lugaresService: LugaresService,
    private route: ActivatedRoute,
    private espaciosService: EspaciosService
  ) { }

  private infoLugar: Lugar;

  cargandoImagenes: boolean;
  cargandoHorarios: boolean;

  opciones: Array<string> = opciones;
  opcionActual: string = "Información";

  informacionImagen: string;
  informacionForm: FormGroup;
  informacionBasicaInicial: InformacionBasicaEspacio;

  horariosForms: Map<number, FormGroup> = new Map<number, FormGroup>();
  valoresInicialesHorarios: Map<number, Horario> = new Map<number, Horario>();
  nuevosHorariosForms: FormGroup[] = [];
  imagenes: Imagen[];
  imagenesIniciales: Imagen[];

  listaDias: string[] = listaDias;
  horas: string[] = listaHoras;

  imagenesPreviews: string[] = [];
  imagenesFiles: any[] = [];
  idEspacio: string;

  ngOnInit() {
    this.headerInfoService.cambiarTituloTarjeta("EDITAR INFORMACIÓN DE ESPACIOS");
    this.headerInfoService.cambiarTextoTarjeta("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo.");
    this.headerInfoService.cambiarImagenTarjeta('./../../../../assets/header/editar-apartamento.svg');

    this.idEspacio = this.route.snapshot.paramMap.get("id");

    this.cargarHorarios();
    this.cargarImagenes();

    this.lugaresService.getLugar(this.idEspacio).subscribe(res => {
      this.infoLugar = res.data.data_lugar;

      this.informacionForm = new FormGroup({
        nombre: new FormControl(this.infoLugar.site_name, [Validators.required]),
        descripcion: new FormControl(this.infoLugar.description, [Validators.required]),
        estado: new FormControl(this.infoLugar.status, [Validators.required])
      });

      this.informacionBasicaInicial = this.informacionForm.value;
    }, err => {
      this.toastService.mostrarToast(err.error.message);
    });
  }

  cargarHorarios() {
    this.espaciosService.traerHorariosEspacio(this.idEspacio).subscribe(res => {
      let horarios: Horario[] = res.data.horarios;
  
      horarios.forEach(horario => {
        const horarioActual = new FormGroup({
          id: new FormControl(horario.id),
          dia: new FormControl(horario.dia, Validators.required),
          hora_desde: new FormControl(horario.hora_desde, Validators.required),
          hora_hasta: new FormControl(horario.hora_hasta, Validators.required),
          valor: new FormControl(horario.valor, Validators.required),
          estado: new FormControl(horario.estado, Validators.required),
          eliminado: new FormControl(false)
        });
        
        this.horariosForms.set(horario.id, horarioActual);
        this.valoresInicialesHorarios.set(horario.id, horarioActual.value);
      });

    }, err => {
      this.toastService.mostrarToast(err.error.message);
    });
  }

  cargarImagenes() {
    this.espaciosService.getImagenesEspacio(this.idEspacio).subscribe(res => {
      this.imagenes = res.data.imagenes;
      this.imagenesIniciales = res.data.imagenes.map(imagen => ({...imagen}));
      
    }, err => {
      this.toastService.mostrarToast(err.error.message);
    });
  }

  handleOpcion(opcion: string): void {
    this.opcionActual = opcion;
  }

  showPreviewInformacion(event: any) {

    const file = (event.target as HTMLInputElement).files[0];

    const reader = new FileReader();
    reader.onload = () => {
      this.informacionImagen = reader.result as string;
    };
    reader.readAsDataURL(file);
  }

  showPreviewImagenes(event: any) {
    const file = (event.target as HTMLInputElement).files[0];

    const reader = new FileReader();
    reader.onload = () => {
      const nuevaImagen: Imagen = {
        url_imagen: reader.result as string,
        file
      };
      this.imagenes.unshift(nuevaImagen);
    };

    reader.readAsDataURL(file);
  }

  eliminarPreviewImagenes(pos: number){
    this.imagenes[pos]["eliminada"] = true;
  }

  agregarHorario(): void {
    this.nuevosHorariosForms.push(new FormGroup({
      id: new FormControl(null),
      dia: new FormControl(null, Validators.required),
      hora_desde: new FormControl(null, Validators.required),
      hora_hasta: new FormControl(null, Validators.required),
      valor: new FormControl(null, Validators.required),
      eliminado: new FormControl(false),
      estado: new FormControl(1)
    }));
  }

  get llavesHorariosForms() {
    return [...this.horariosForms.keys()];
  }

  public numSequence(n: number): Array<number> {
    return Array(n);
  }

  get formulariosValidos() {
    let validos = true;
    
    this.horariosForms.forEach(form => validos = validos && (form.valid || form.get("eliminado").value));
    this.nuevosHorariosForms.forEach(form => validos = validos && (form.valid || form.get("eliminado").value));

    return validos;
  }

  get hayCambios() {
    let cambios = false;
    
    this.valoresInicialesHorarios.forEach(horario => {
      const idHorario = horario["id"];
      const formularioHorarioActualValor = this.horariosForms.get(idHorario).value;

      cambios = cambios || Object.keys(horario).some(key => formularioHorarioActualValor[key] !== horario[key]);
    });

    cambios = cambios || this.nuevosHorariosForms.some(horario => !horario.get("eliminado").value);

    return cambios;
  }

  get hayCambiosInformacionBasica() {
    return Object.keys(this.informacionBasicaInicial).some(key => this.informacionBasicaInicial[key] !== this.informacionForm.get(key).value);
  }
  
  get hayCambiosImagenes() {
    let cambios = false;
    this.imagenes.forEach((imagen, index) => {
      const imagenInicial = this.imagenesIniciales[index];
      cambios = cambios || Object.keys(imagen).some(key => (imagenInicial && imagenInicial[key]) !== imagen[key]);
    });

    return cambios;
  }

  public guardarCambios() {
    if(this.formulariosValidos) {
      this.cargandoHorarios = true;
      this.espaciosService.actualizarHorarios(this.infoLugar.site_id, this.valoresInicialesHorarios, this.horariosForms, this.nuevosHorariosForms).subscribe((results: any[]) => {
        this.nuevosHorariosForms = [];
        
        results.forEach(res => {
          if(res.nuevoHorario) {
            const idHorario = res.horario.get("id").value;

            this.horariosForms.set(idHorario, res.horario);
            this.valoresInicialesHorarios.set(idHorario, res.horario.value);
          }
        });

        this.valoresInicialesHorarios = new Map <number, Horario>();
        this.horariosForms.forEach(horario => {
          const idHorario = horario.get("id").value;

          if(horario.get("eliminado").value) {
            this.horariosForms.delete(idHorario);
          } else {
            this.valoresInicialesHorarios.set(idHorario, horario.value);
          }
        });

        this.cargandoHorarios = false;

        this.toastService.mostrarToast("Los horarios fueron actualizados");
      }, err => {
        this.cargandoHorarios = false;
        this.toastService.mostrarToast(err.error.message);
      });
    } else {
      this.toastService.mostrarToast("Por favor llene todos los campos de los horarios");
    }
  }

  public cancelarCambios() {
    this.horariosForms = new Map<number, FormGroup>();
    this.nuevosHorariosForms = [];

    this.valoresInicialesHorarios.forEach(horario => {
      const horarioActual = new FormGroup({
        id: new FormControl(horario.id),
        dia: new FormControl(horario.dia, Validators.required),
        hora_desde: new FormControl(horario.hora_desde, Validators.required),
        hora_hasta: new FormControl(horario.hora_hasta, Validators.required),
        valor: new FormControl(200000, Validators.required),
        eliminado: new FormControl(false)
      });
      
      this.horariosForms.set(horario.id, horarioActual);
    });
  }

  get imagenesVisibles() {
    return this.imagenes
            .map((imagen, index) => ({...imagen, posicion: index}))
            .filter(imagen => !imagen.eliminada);
  }

  public guardarImagenes() {
    this.cargandoImagenes = true;
    this.espaciosService.actualizarImagenesEspacio(this.infoLugar.site_id, this.imagenes).subscribe((results: any[]) => {
      this.cargandoImagenes = false;
      this.imagenes = this.imagenes.filter(imagen => imagen.id);
      results.forEach(res => {
        if(res.id) {
          this.imagenes.push(res);
        } else if(res?.data?.message === "Imagen eliminado") {
          const imageIndex = this.imagenes.findIndex(imagen => String(imagen.id) === res.data.imagen);
          this.imagenes.splice(imageIndex, 1);
        }
      })

      this.imagenesIniciales = this.imagenes.map(imagen => ({...imagen}));
      this.toastService.mostrarToast("Las imágenes fueron actualizadas");
    }, err => {
      this.cargandoImagenes = false;
      this.toastService.mostrarToast(err.error.message);
    });
  }

  public cancelarCambiosImagenes() {
    this.imagenes = this.imagenesIniciales.map(imagen => ({...imagen}));
  }

  public guardarInformacionBasica() {
    this.espaciosService.actualizarInformacionBasica(this.idEspacio, this.informacionForm.value).subscribe(res => {
      this.informacionBasicaInicial = this.informacionForm.value;
      
      this.toastService.mostrarToast("La información fue actualizada");
    }, err => {
      this.toastService.mostrarToast(err.error.message);
    });
  }

  public cancelarCambiosInformacionBasica() {
    this.informacionForm = new FormGroup({
      nombre: new FormControl(this.informacionBasicaInicial.nombre, [Validators.required]),
      descripcion: new FormControl(this.informacionBasicaInicial.descripcion, [Validators.required]),
      estado: new FormControl(this.informacionBasicaInicial.estado, [Validators.required])
    });
  }

  get estado() {
    return this.informacionForm.get("estado").value;
  }

  public cambiarEstado(estado: number) {
    this.informacionForm.get("estado").setValue(estado);
  }

  onFileDropped($event) {
    this.prepareFilesList($event);
  }

  prepareFilesList(files: Array<any>) {
    for (const file of files) {
      const reader = new FileReader();
      reader.onload = () => {
        const nuevaImagen: Imagen = {
          url_imagen: reader.result as string,
          file
        };
        this.imagenes.unshift(nuevaImagen);
      };
      reader.readAsDataURL(file);   
    }
  }
}
